import { DeliveryService } from '@/core/services/delivery.service'
import { DeliveryI } from '@/core/interfaces/delivery.interface'
import {
    DeliveryExpressOrderPayloadT,
    DeliveryGetCitiesResponseT,
    DeliveryGetOrderResponseT,
    DeliveryGetOrdersFilters,
    DeliveryGetOrdersResponseT,
    DeliveryGetTariffsResponseT,
    DeliveryGetTasksResponseT,
    DeliveryPointT,
    DeliveryUpdateStatusResponseT,
} from '../types/delivery.types'

const deliveryService = new DeliveryService()

class DeliveryRealisation implements DeliveryI {
    getCities(page: number, search?: string, limit?: number): Promise<DeliveryGetCitiesResponseT> {
        return deliveryService.getCities(page, search, limit)
    }

    getTariffs(coordinates: DeliveryPointT[]): Promise<DeliveryGetTariffsResponseT> {
        return deliveryService.getTariffs(coordinates)
    }

    createExpressOrder(payload: DeliveryExpressOrderPayloadT): Promise<void> {
        return deliveryService.createExpressOrder(payload)
    }

    getExpressOrders(filters: DeliveryGetOrdersFilters): Promise<DeliveryGetOrdersResponseT> {
        return deliveryService.getExpressOrders(filters)
    }

    getExpressOrder(order_id: number): Promise<DeliveryGetOrderResponseT> {
        return deliveryService.getExpressOrder(order_id)
    }

    async getTasks(page: number): Promise<DeliveryGetTasksResponseT> {
        return await deliveryService.getTasks(page)
    }

    refreshStatus(order_id: number): Promise<DeliveryUpdateStatusResponseT> {
        return deliveryService.refreshStatus(order_id)
    }

    cancelOrder(id: number): Promise<DeliveryUpdateStatusResponseT> {
        return deliveryService.cancelOrder(id)
    }

    cancelOrderByReceiver(id: number): Promise<DeliveryUpdateStatusResponseT> {
        return deliveryService.cancelOrderByReceiver(id)
    }

    addToAccrual(order_id: number): Promise<void> {
        return deliveryService.addToAccrual(order_id)
    }

    massApprove(form_data: FormData): Promise<void> {
        return deliveryService.massApprove(form_data)
    }
}

export const delivery = new DeliveryRealisation()
